import React from "react";
import { Button, Modal, Table } from "antd";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";

export interface BatchCancelSplitOrderResult {
    originalId: string;

    error: string;
}

interface BatchCancelSplitOrderResultModalProps extends InjectBaseModalProps {
    successCount: number;

    results: BatchCancelSplitOrderResult[];
}

const BatchCancelSplitOrderResultModal: React.FC<BatchCancelSplitOrderResultModalProps> = function (props) {
    const { open, onCancel, successCount, results } = props;

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            title="批量取消拆分订单结果"
            width={700}
            footer={
                <>
                    <Button type="primary" onClick={onCancel}>
                        知道了
                    </Button>
                </>
            }
        >
            <div className="mb10">
                <span>{successCount}个子订单取消拆分成功，</span>
                <span className="text-error">{results.length}个订单取消拆分失败</span>
            </div>

            <Table
                columns={[
                    {
                        title: "订单编号",
                        key: "originalId",
                        dataIndex: "originalId",
                    },
                    {
                        title: "失败原因",
                        key: "error",
                        dataIndex: "error",
                    },
                ]}
                dataSource={results}
                pagination={false}
            />
        </Modal>
    );
};

export default React.memo(BatchCancelSplitOrderResultModal);
